import { Scene } from "./components";

function App() {
  return (
    <>
      <Scene />
    </>
  );
}

export default App;
